import { Skeleton } from "@mui/material";
import TitleCover from "components/shared/TitleCover";
import UserAvatar from "components/shared/UserAvatar";
import type { TopPerformingData } from "store/analyticsStore";

import styles from "../style.module.scss";

/**
 * Render top title data list
 */
interface ITopTitleList {
    /**
     * Top performing data title
     */
    topTitleData: TopPerformingData[];
    /**
     * Is data title loading
     */
    isLoading: boolean;
}
export const TopTitleList = ({ topTitleData, isLoading }: ITopTitleList) => {
    return (
        <>
            {!isLoading &&
                topTitleData?.map((title) => {
                    return (
                        <div className={styles["top-data-row"]} key={`top-data-row-${title.titleId}`}>
                            <div className={styles["top-data-row-left"]}>
                                <TitleCover
                                    coverUrl={title.avatarUrl}
                                    title={title.name}
                                    style={{ width: "30px", fontSize: "14px" }}
                                />
                                <div className={styles["top-data-title-wrapper"]}>
                                    <span className={styles["title"]} title={title.name}>
                                        {title.name}
                                    </span>
                                    <span className={styles["author"]}>{title.author}</span>
                                </div>
                            </div>
                            <span className={styles["amount"]}>{title.amount}</span>
                        </div>
                    );
                })}
            {isLoading && <LoadingContent />}
        </>
    );
};

/**
 * Render top beneficiar data list
 */
interface ITopBeneficiarList {
    topBeneficiarData: TopPerformingData[];
    /**
     * Is data title loading
     */
    isLoading: boolean;
}
export const TopBeneficiarList = ({ topBeneficiarData, isLoading }: ITopBeneficiarList) => {
    return (
        <>
            {!isLoading &&
                topBeneficiarData?.map((beneficiar) => {
                    const [surname, name] = beneficiar.name.split(" ", 2);

                    return (
                        <div className={styles["top-data-row"]} key={`top-data-row-${beneficiar.id}`}>
                            <div className={styles["top-data-row-left"]}>
                                <UserAvatar
                                    name={name}
                                    surname={surname}
                                    size="x-small"
                                    avatarUrl={beneficiar.avatarUrl}
                                />
                                <span className={styles["title"]} title={beneficiar.name}>
                                    {beneficiar.name}
                                </span>
                            </div>
                            <span className={styles["amount"]}>{beneficiar.amount}</span>
                        </div>
                    );
                })}

            {isLoading && <LoadingContent />}
        </>
    );
};

/**
 * Local loading content for top title/beneficiar list analytics
 */
const LoadingContent = () => {
    const loadingData = [1, 2, 3, 4];

    return (
        <>
            {loadingData.map((e, i) => {
                return (
                    <div className={styles["top-data-row"]} key={`top-data-row-skeleton-${i}`}>
                        <div className={styles["top-data-row-left"]}>
                            <Skeleton sx={{ width: "100%" }} />
                        </div>
                        <span className={styles["amount"]}>
                            <Skeleton sx={{ width: "4rem" }} />
                        </span>
                    </div>
                );
            })}
        </>
    );
};
